import Axios from "@/plugins/axios";

class CityApi {
    getCity(id) {
        return Axios.get('api/cities/' + id);
    }

    getCities(q) {
        return Axios.get('api/cities', {
            params: {search: typeof q === 'string' ? q.trim() : ''}
        })
            .then(response => {
                return response.data;
            });
    }
}

export default new CityApi();
